// iter179 — Rate & Inventory landing. Currently ships as "Coming Soon"
// per product spec; the real Rate & Inventory workspace will be built later.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Package, Sparkles } from 'lucide-react';

const RateInventoryScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white pb-24" data-testid="rate-inventory-screen">
      <div className="sticky top-0 bg-white border-b border-gray-200 z-10">
        <div className="flex items-center gap-3 px-4 py-3 max-w-2xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="rate-inventory-back-btn"
            aria-label="Back"
          >
            <ChevronLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div className="flex items-center gap-2">
            <Package className="w-5 h-5 text-[#1B2A7B]" />
            <h1 className="text-base font-semibold text-gray-900">Rate &amp; Inventory</h1>
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-16 text-center">
        <div className="w-20 h-20 rounded-2xl bg-[#EEF1FC] flex items-center justify-center mx-auto mb-5">
          <Sparkles className="w-10 h-10 text-[#1B2A7B]" />
        </div>
        <h2 className="text-2xl font-bold text-[#1B2A7B] mb-2" data-testid="rate-inventory-coming-soon">Coming Soon</h2>
        <p className="text-sm text-gray-600 leading-relaxed max-w-md mx-auto">
          A full Rate &amp; Inventory workspace is on the way — bulk price updates,
          channel-level overrides, and stop-sell controls will land here shortly.
        </p>
      </div>
    </div>
  );
};

export default RateInventoryScreen;
